import styled from '@emotion/styled';
import { Container, Link, Typography } from '@mui/material';
import {PolicyWordingsSection, FormsSection, LegalSection, OtherSection} from '../components/DownloadSections';



const DocumentRoot = styled('div')(({ theme }) => ({
    padding: '50px 0',
}));

const LegalLink = styled(Link)(({ theme }) => ({
    marginBottom: '20px',
}));

const LinkContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
}));

const Downloads = () => {
    return (
        <DocumentRoot>
            <Container maxWidth="lg">
                <Typography variant="h3" marginBottom={3}>
                    Downloads
                </Typography>
                <PolicyWordingsSection />
                <FormsSection />
                <LegalSection />
                <OtherSection />
            </Container>
        </DocumentRoot>
    );
};

export default Downloads;
